/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Tabs, TabsProps, Tag } from "antd";
import Filters from "./Components/Filters";
import { useState } from "react";
import Contracts from "./Components/Contracts";
import PotentialDeals from "./Components/PotentialDeals";

export default function Deals(props: any) {
  const [archived, isArchived] = useState(false);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <>
          Contracts <Tag>{props.data.contracts.length}</Tag>
        </>
      ),
      children: <Contracts data={props.data.contracts} />,
    },
    {
      key: "2",
      label: (
        <>
          Potential deals <Tag>{props.data.potentialDeals.length}</Tag>
        </>
      ),
      children: <PotentialDeals data={props.data.potentialDeals} />,
    },
  ];
  return (
    <div className="dealsContainer">
      <Card className="dealsInsideTabs">
        <div className="dealsFilter">
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
          />
        </div>
        <Tabs defaultActiveKey="1" items={tabItems} className="profileTabs" />
      </Card>
    </div>
  );
}
